<template>
    <span class="v-icon material-symbols-rounded" :class="`${weightClass} ${sizeClass}`" ><slot></slot></span>
</template>
<script setup lang="ts">
const props = defineProps({
    stroke: {
        type: Number,
        default: 3 // 1 - 7
    },
    size: {
        type: String,
        default: '1' // n6 - n2, 1 - 15
    }
})
const weightClass = `material-symbols-weight-${props.stroke}`
const sizeClass = `material-symbols-size-${props.size}`
</script>